<template>
  <v-hover v-slot="{ hover }">
    <v-card
      class="mx-auto"
      :hover="hover"
    >
      <v-row
        class="mb-4 px-2 cursor-pointer"
        align="center"
        justify="space-around"
        @click="clickReward(reward.id)"
      >
        <v-col>
          <ImageFromReference
            v-if="reward.image !== null"
            :max-width="200"
            :max-height="200"
            :reference="reward.image.small"
          />

          <v-icon
            v-if="reward.image === null"
            class="ml-5"
            large
          >
            mdi-image-off-outline
          </v-icon>
        </v-col>
        <v-col>
          <div class="caption grey--text">
            Title
          </div>
          <div>{{ reward.title }}</div>
        </v-col>
        <v-col>
          <div class="caption grey--text">
            Description
          </div>
          <div>{{ reward.description }}</div>
        </v-col>
        <v-col>
          <div class="caption grey--text">
            Tags
          </div>
          <v-chip
            v-for="(tag, index) in reward.tags"
            :key="index"
            class="ma-1"
          >
            {{ tag | capitalize }}
          </v-chip>
        </v-col>
        <v-col>
          <div class="caption grey--text">
            Created
          </div>
          <div v-if="reward.createdAt">
            {{ reward.createdAt.toDate() | formatDate }}
          </div>
        </v-col>
        <v-col>
          <div class="text-end">
            <v-chip
              v-if="reward.public"
              color="success"
            >
              Public
            </v-chip>
            <v-chip
              v-else
              color="warning"
            >
              Private
            </v-chip>

            <v-chip
              v-if="readOnly"
              class="ml-1"
              color="yellow"
            >
              Read Only
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-hover>
</template>


<script>

import ImageFromReference from '@/components/ImageFromReference.vue';

export default {
  name: 'RewardRow',
  components: {
    ImageFromReference,
  },
  props: {
    reward: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    clickReward(rewardId) {
      if (this.readOnly) {
        alert('Only the owner can edit this item.');
        return;
      }

      this.$emit('click', rewardId);
    },


  },

};
</script>
